import { connect, useDataItem } from 'scrivito'

import { DynamicListContactTab } from './DynamicListContactTab'
import { StaticListContactTab } from './StaticListContactTab'
import { DataClassName } from '@/Data/const'

interface ListContactTabProps {
  contactEntity: DataClassName.COMPANY | DataClassName.PERSON
}

export const ListContactTab: React.FC<ListContactTabProps> = connect(
  ({ contactEntity }) => {
    const dataItem = useDataItem()
    const listType = dataItem?.get('type') as 'static' | 'dynamic' | undefined

    if (listType === 'dynamic') {
      return <DynamicListContactTab contactEntity={contactEntity} />
    }

    return <StaticListContactTab contactEntity={contactEntity} />
  },
)
